import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Product } from '../models/product.model';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'ft-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss'],
})
export class ProductCardComponent {
  @Input() product!: Product;
  @Input() productCart: Product[] = [];


  @Output() selectedProductMedia = new EventEmitter();

  defaultQuantity = environment.defaultQuantity;

  selectedDocMedia!: any;
  isPdfPreview = false;
  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5,
    },
    {
      breakpoint: '768px',
      numVisible: 3,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
    },
  ];

  // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
  ngOnInit(): void {
   
  }

  getCardMediaUrl(): string {
    let url = '';
    if (this.product.medias && this.product.medias.length > 0) {
            url = this.product.medias[0].url ?? '';
    }
    return url;
  }

  onSelectProductMedia(media: any) {
    this.selectedProductMedia.emit(media);
    if (media.fileType === 'doc') {
      this.isPdfPreview = true;
      this.selectedDocMedia = {
        url: media.url,
        name: media.name
      };
    }
  }

  addToCart(cartProd: Product){
    const idx = this.productCart.findIndex(_ => _.productId === cartProd.productId);
    if(idx < 0){
      cartProd.inCart = true;
      cartProd.quantity = this.defaultQuantity;
      this.productCart.push(cartProd);
    }
  }
}
